import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PricingAndAccessService } from 'src/app/core/services/pricing-and-access/pricing-and-access.service';
import { StripePaymentService } from 'src/app/core/services/stripe-payment.service';
 
@Component({
  selector: 'app-pricing-and-access',
  templateUrl: './pricing-and-access.component.html',
  styleUrls: ['./pricing-and-access.component.css']
})
export class PricingAndAccessComponent implements OnInit {
 
  isUserLogin: boolean = false;
  userId: number;
  isFounder: boolean = false;
  hotlineMsg: string = '';
  cardArray;
  cardDetail;
  handler: any;
  image: any;
  userEmailAddress: String;

  constructor(private router: Router,
              private pricingService: PricingAndAccessService,
              private spinner: NgxSpinnerService,
              private stripePayment: StripePaymentService
  ) { }
 
  ngOnInit(): void {
    // Getting the price cards
    this.pricingService.getPricingAndAccess().subscribe((res) => {
      this.cardArray = res.pricingAccess;
      this.isFounder = res.foundingPatron;
      this.userEmailAddress = res.userEmailAddress;
      this.userId = res.loggedUserId;
      if(this.userId > 0){
        this.isUserLogin = true;
      }
      this.cardArray.forEach(card => {
        // For card description to be an array
        card.description = card.description.split('#') // Splitting the sentence on "#"
                                            .map(sentence => sentence.trim()) // Removing white space
                                            .filter(sentence => sentence.length > 0); // Removing empty string
      });
    });
  }
 
  //Handling the card button
  handleButton(item) {
    if (this.isUserLogin) { // If user is logged in
      if (item.amount === 0) {
        this.router.navigate([""]);
      } else {
        // Show the Stripe payment modal
        this.spinner.show();
        this.handlePayment(item);       
      }
    } else {
      localStorage.setItem('redirectUrl', this.router.url);
      localStorage.setItem('redirectCount', '2');
      this.router.navigate(['/login']);
    }
  }

  handlePayment(item: any) {
    this.spinner.show();
    this.image = "../../../../assets/images/img_pricing.png";
    let description = 'Getting extra benefits';
    // Call the stripe payment service's openCheckout function
    this.stripePayment.openCheckout(item.title, item.amount, description, this.image, this.userEmailAddress, (tokenId: any) => {
      this.onTokenReceived(tokenId, item);
    });
  }

  onTokenReceived(tokenId: any, item: any) {
    // Process the payment using the token received
    this.pricingService.createPayment(tokenId, item.amount * 100, item.id)
      .subscribe(() => {
        alert("Payment successful!!");
        this.spinner.hide();
        localStorage.setItem('paymentRedirect', 'true');
        this.router.navigate(['pricing-and-access/payment-receipt/', item.id]);
      }, (err) => {
        alert("Payment failed!!");
        this.spinner.hide();
        window.location.reload();
    });
  }  
 
  //Handling hotline submit
  handleHotlineSubmit(){
    this.pricingService.hotlineMsg(this.hotlineMsg).subscribe(data => {
      this.resetHotlineMsg();
    });
  }

  resetHotlineMsg() {
    this.hotlineMsg = '';
  }
}